import Backbone from 'backbone';
import _ from 'underscore';
import DialogViewMixin from 'app/mixins/views/DialogViewMixin';
import html from './termsAndConditionsDialog.template.html';
const template = _.template(html);
import $ from 'jquery';
import 'jquery-ui-lib'; // specifically import the lib and the dialog wrapper in order not to make unnecessary requests for other ui-wrappers
import 'app/libWrappers/jqueryui/jqueryui-dialog.wrapper';
import { createLabelsMixin } from 'app/mixins/views/LabelsMixin';

const COUNTRIES = {
    'en-us': { code: 'en-us', name: 'United States', url: 'http://www.lexisnexis.com/terms/general.aspx' },
    'en-gb': { code: 'en-gb', name: 'United Kingdom', url: 'http://www.lexisnexis.com/terms/general.aspx' },
    de: {
        code: 'de',
        name: 'Germany',
        url: '/termsAndConditions/' + encodeURIComponent('newsdesk-t-and-c-25052018.pdf')
    },
    fr: {
        code: 'fr',
        name: 'France',
        url: '/termsAndConditions/' + encodeURIComponent('Contrat_d_Abonnement_Newsdesk_LNBIS_2016_pour_le_web.pdf')
    },
    nl: {
        code: 'nl',
        name: 'Netherlands',
        url: '/termsAndConditions/' + encodeURIComponent('Service-TC-Dutch-Law-English-language-25052018.pdf')
    },
    ru: {
        code: 'ru',
        name: 'Russia (Russian)',
        url: '/termsAndConditions/' + encodeURIComponent('Newsdesk_T&C_Russia_05_2015_(Russian_language).pdf')
    },
    'ru-en': {
        code: 'ru-en',
        name: 'Russia (English)',
        url: '/termsAndConditions/' + encodeURIComponent('Newsdesk_T&C_Russia_(English_language)_05_2015.pdf')
    },
    other: { code: 'other', name: 'Rest of the World', url: 'http://www.lexisnexis.com/terms/general.aspx' }
};

const country_selector = '.js-terms-and-conditions-popup__country';

export default Backbone.View.extend({
    mixins: [DialogViewMixin, createLabelsMixin()],

    events: {
        'change .terms-and-conditions-popup__country': 'onChangeCountry',
        'click .terms-and-conditions-popup__view-button': 'onClickViewButton'
    },

    initialize() {
        this.render();
    },

    render() {
        this.$el.html(template(this));

        this.transformToJqueryDialog({
            width: '650px',
            minHeight: '400px',
            resizable: false,
            title: this.t('common:termsAndConditionsDialog.title')
        });

        this.populateCountriesDropdown();
    },

    populateCountriesDropdown() {
        let countryDropdown = this.$(country_selector);

        _.each(COUNTRIES, (countryItem) => {
            countryDropdown.append(
                $('<option/>', {
                    value: countryItem.code,
                    text: countryItem.name
                })
            );
        });
        this.setDefaultSelectionValue();
    },

    onChangeCountry() {
        localStorage.setItem('termsAndConditionsCountry', this.$(country_selector).val());
    },

    onClickViewButton() {
        let selectedCountry = this.$(country_selector).val();

        window.open(COUNTRIES[selectedCountry].url, '_blank');
        this.closeJqueryDialog();
    },

    setDefaultSelectionValue() {
        let countryDropdown = this.$(country_selector);
        let countryValue =
            localStorage.getItem('termsAndConditionsCountry') !== null
                ? localStorage.getItem('termsAndConditionsCountry')
                : (window.navigator.userLanguage || window.navigator.language).toLowerCase();
        if (!_.has(COUNTRIES, countryValue)) {
            countryValue = COUNTRIES.other.code;
        }
        countryDropdown.val(countryValue);
    }
});
